import { graphql } from 'react-relay';

export default graphql`
  query ReferralCodeGenerate_Query {
    viewer {
      id
      ...ReferralCodeGenerate_viewer
    }
  }
`;
